import { Component } from '@angular/core';
import { AuthService, TranslationService } from '@spartacus/core';
import { LoginComponent } from '@spartacus/user/account/components';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { MenuMobileService } from '../../store-front/misc/header/menu-mobile.service';

@Component({
  selector: 'cx-login',
  templateUrl: './custom-login.component.html',
  styleUrl: './custom-login.component.scss',
  standalone: false,
})
export class CustomLoginComponent extends LoginComponent {
  constructor(
    private _auth: AuthService,
    private _userAccount: UserAccountFacade,
    private _translationService: TranslationService,
    private menuService: MenuMobileService,
  ) {
    super(_auth, _userAccount, _translationService);
  }

  closeMainMenu() {
    this.menuService.close();
  }
}
